export default __webpack_public_path__ + "static/media/nft-13.5d8e5c8f.png";